import React from "react";
import { useTranslation } from "next-i18next";

interface AvailableCardProps {
  counts: number;
}

function AvailableCard(props: AvailableCardProps) {
  const { counts } = props;
  const { t } = useTranslation("common");

  return (
    <div className="md:w-[392px] w-full md:h-[242px] h-[168px] flex flex-col justify-center items-center text-black bg-primary p-auto">
      <div className="display-3 md:text-display-2 ">{counts}</div>
      <div className="mt-[22px] captionText uppercase" data-cy="Availibility1">
        {t("quests", { count: counts })}&nbsp;{t("status.available")}
      </div>
    </div>
  );
}

export default AvailableCard;
